<template>
  <router-view/>
</template>

<script>
export default {
    name: 'App',
    created() {
        //��ҳ�����ʱ��ȡsessionStorage���״̬��Ϣ
        if (sessionStorage.getItem("store")) {
            this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))));
            sessionStorage.removeItem('store');
        }

        //��ҳ��ˢ��ʱ��vuex�����Ϣ���浽sessionStorage��
        window.addEventListener("beforeunload", () => {
            sessionStorage.setItem("store", JSON.stringify(this.$store.state))
        })

      //���ResizeObserver loop completed with undelivered notifications.
      const debounce = (fn, delay) => {
        let timer = null;
        return function () {
          let context = this;
          let args = arguments;
          clearTimeout(timer);
          timer = setTimeout(function () {
            fn.apply(context, args);
          }, delay);
        }
      }

      const _ResizeObserver = window.ResizeObserver;
      window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
        constructor(callback) {
          callback = debounce(callback, 16);
          super(callback);
        }
      }
    }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
